import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { t } from '../i18n/es.js';
import { UserCard } from './UserCard.js';

// SVG icons copiados directo de /Users/cristian.fernandez/Downloads/zengine_mvp_1.html
// (líneas 597-628). Mantener trazos / paths idénticos para preservar estilo visual.
const ICONS = {
  dashboard: (
    <svg className="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="9" />
      <rect x="14" y="3" width="7" height="5" />
      <rect x="14" y="12" width="7" height="9" />
      <rect x="3" y="16" width="7" height="5" />
    </svg>
  ),
  conexiones: (
    <svg className="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  campanas: (
    <svg className="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 11l18-5v12L3 14v-3z" />
      <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
    </svg>
  ),
  templates: (
    <svg className="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
  ),
  variables: (
    <svg className="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="4 17 10 11 4 5" />
      <line x1="12" y1="19" x2="20" y2="19" />
    </svg>
  ),
  reportes: (
    <svg className="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </svg>
  ),
  estado: (
    <svg className="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  config: (
    <svg className="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
};

const ITEMS: Array<{ to: string; label: string; icon: JSX.Element; end?: boolean }> = [
  { to: '/', label: t.nav.dashboard, icon: ICONS.dashboard, end: true },
  { to: '/conexiones', label: t.nav.conexiones, icon: ICONS.conexiones },
  { to: '/campanas', label: t.nav.campanas, icon: ICONS.campanas },
  { to: '/flujos', label: 'Flujos', icon: ICONS.variables },
  { to: '/templates', label: t.nav.templates, icon: ICONS.templates },
  { to: '/variables', label: t.nav.variables, icon: ICONS.variables },
  { to: '/reportes', label: t.nav.reportes, icon: ICONS.reportes },
  { to: '/estado', label: t.nav.estado, icon: ICONS.estado },
  { to: '/configuracion', label: t.nav.config, icon: ICONS.config },
];

export function Sidebar(): JSX.Element {
  return (
    <aside
      className="row-span-2 flex flex-col overflow-y-auto px-3 py-4"
      style={{ background: 'var(--bg-2)', borderRight: '1px solid var(--border)' }}
    >
      <div
        className="flex items-center gap-2.5 px-2 pb-5 mb-3"
        style={{ borderBottom: '1px solid var(--border)' }}
      >
        <div
          className="w-[30px] h-[30px] rounded-lg flex items-center justify-center shrink-0"
          style={{ background: 'var(--brand)' }}
        >
          <svg viewBox="0 0 20 20" width="16" height="16" fill="none" aria-hidden>
            <path d="M4 4h12L6 16h12" stroke="white" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div className="text-[16px] font-semibold tracking-tight">ZEngine</div>
      </div>

      <nav className="flex flex-col gap-px" aria-label="Navegación principal">
        {ITEMS.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-3 px-2.5 py-2 rounded-[6px] text-[13.5px] transition-colors',
                isActive ? 'bg-surface text-ink-1 [&_.nav-icon]:text-brand' : 'text-ink-3 hover:bg-surface hover:text-ink-2',
              )
            }
          >
            {it.icon}
            <span>{it.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="mt-auto pt-3.5" style={{ borderTop: '1px solid var(--border)' }}>
        <UserCard />
      </div>
    </aside>
  );
}
